/**
 * The entity name a deep page shows in the mobile top bar (design b4), for example the track
 * name on a track page.
 *
 * The page component sits above `SMLContainer` (it renders the container itself), so a React
 * context from the container cannot reach it. This tiny store can: the page writes with
 * `useMobilePageTitle`, and the top bar reads with `useMobilePageTitleValue`.
 */
type Listener = () => void;

let currentTitle: string | undefined;
const listeners = new Set<Listener>();

export const mobilePageTitleStore = {
  get: (): string | undefined => currentTitle,
  set: (title: string | undefined): void => {
    if (title === currentTitle) {
      return;
    }
    currentTitle = title;
    listeners.forEach((listener) => listener());
  },
  subscribe: (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
